import { useContext, useEffect } from 'react';

import * as turf from '@turf/turf';

import { MapContext } from 'features/map/MapContext';
import { drawSubscriptionBoundary } from 'features/map/utils/mapCommon';
import { fitBoundsToBbox } from 'features/map/utils/mapUtils';
import { Feature, Geometry, MultiPolygon, Polygon } from 'geojson';

export function isGeomGood(bound): boolean {
  return Boolean(
    bound &&
    bound.coordinates &&
    bound.coordinates.length > 0 &&
    turf.booleanValid(bound),
  );
}

export function useMapSubscriptionBoundary(
  subscriptionBoundary: Feature<MultiPolygon | Polygon>,
  boundary: Feature | Geometry | undefined,
) {
  const { refMap, mapReady, refStyleReady, mapStyle } = useContext(MapContext);
  useEffect(() => {
    if (mapReady && refStyleReady.current) {
      drawSubscriptionBoundary(refMap.current, mapStyle, subscriptionBoundary);
      if (subscriptionBoundary) {
        if (!boundary) {
          fitBoundsToBbox(refMap.current, subscriptionBoundary.geometry, 0.1);
        }
      }
    }
  }, [mapReady, subscriptionBoundary, mapStyle]);
}
